import { COMBAT } from '../data/balance';

/** 연속 명중 콤보. 빗나가거나 창이 끝나면 끊긴다. */
export class ComboTracker {
  count = 0;
  remainMs = 0;

  tick(deltaMs: number): void {
    if (this.count <= 0) return;
    this.remainMs -= deltaMs;
    if (this.remainMs <= 0) this.reset();
  }

  noteHit(): number {
    this.count += 1;
    this.remainMs = COMBAT.comboWindowMs;
    return this.count;
  }

  noteMiss(): void {
    this.reset();
  }

  reset(): void {
    this.count = 0;
    this.remainMs = 0;
  }

  /** 1타부터. 2타부터 보너스 */
  damageMul(): number {
    if (this.count <= 1) return 1;
    const stacks = Math.min(this.count - 1, COMBAT.comboMaxStacks);
    return 1 + stacks * COMBAT.comboBonusPerHit;
  }
}
